import { render } from "./OuterDetailPage.vue?vue&type=template&id=2283651f&scoped=true&ts=true"
import script from "./OuterDetailPage.vue?vue&type=script&lang=ts"
export * from "./OuterDetailPage.vue?vue&type=script&lang=ts"

import "./OuterDetailPage.vue?vue&type=style&index=0&id=2283651f&lang=scss&scoped=true"

import exportComponent from "/codebuild/output/src245414373/src/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2283651f"]])

export default __exports__